import { render, staticRenderFns } from "./organization_payments.vue?vue&type=template&id=2a652aca&scoped=true&"
import script from "./organization_payments.vue?vue&type=script&lang=js&"
export * from "./organization_payments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a652aca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a652aca')) {
      api.createRecord('2a652aca', component.options)
    } else {
      api.reload('2a652aca', component.options)
    }
    module.hot.accept("./organization_payments.vue?vue&type=template&id=2a652aca&scoped=true&", function () {
      api.rerender('2a652aca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/organizations/tabs/organization_payments.vue"
export default component.exports